import { Upload } from "lucide-react";
import React, { useState } from "react";
import { generateArtworkPDF } from "../../../utils/generarPDF";

export const CreatePDF = ({
  isOpen,
  setIsOpen,
  artwork,
  artists,
  suppliers,
  owners,
  divisas,
}) => {
  const [selectedTypes, setSelectedTypes] = useState({
    images: false,
    videos: false,
    files: false,
  });

  const closeModal = async () => {
    await generateArtworkPDF(
      artwork,
      artists,
      suppliers,
      owners,
      divisas,
      selectedTypes.images,
      selectedTypes.videos,
      selectedTypes.files
    );
    setIsOpen(false);
  };

  const handleCheckboxChange = (type) => {
    setSelectedTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Modal Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={closeModal}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show d-block"
        style={{ zIndex: 1050 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title">Download</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {/* File Type Selection */}
              <div className="d-flex">
                <div className="col-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="images"
                      checked={selectedTypes.images}
                      onChange={() => handleCheckboxChange("images")}
                    />
                    <label className="form-check-label" htmlFor="images">
                      Images
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="videos"
                      checked={selectedTypes.videos}
                      onChange={() => handleCheckboxChange("videos")}
                    />
                    <label className="form-check-label" htmlFor="videos">
                      Videos
                    </label>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="files"
                      checked={selectedTypes.files}
                      onChange={() => handleCheckboxChange("files")}
                    />
                    <label className="form-check-label" htmlFor="files">
                      Files
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setIsOpen(false)}
              >
                Back
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={closeModal}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
